import { RyderCupTeam } from "../_interfaces"

export enum RyderCupTeamKey {
  USA = 'usa',
  EUROPE = 'europe',
}

export const RYDER_CUP_TEAMS: Record<RyderCupTeamKey, RyderCupTeam> = {
    [RyderCupTeamKey.USA]: {
        name: 'golf.rydercup.team.usa',       // appString use
        code: 'us',                           // Country Code for Emoji Flags use
        color: '#B31942',                   // Old Glory Red
    },
    [RyderCupTeamKey.EUROPE]: {
        name: 'golf.rydercup.team.europe',    // appString use
        code: 'eu',                           // Country Code for Emoji Flags use
        // color: '#003399',                // Light Mode European Blue
        color: '#004494'                    // Dark Mode European Blue
    },
};

export const getRyderCupTeam = (key?: RyderCupTeamKey | null): RyderCupTeam | undefined => 
    (key ? RYDER_CUP_TEAMS[key] : undefined);